var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',[_c('v-card-text',[_c('img',{attrs:{"src":_vm.images.temp_1}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }